import React, { useEffect } from 'react';
import {
  View,
  Text,
  ImageBackground,
  StyleSheet,
  useWindowDimensions,
} from 'react-native';
import { useDispatch, useSelector } from 'react-redux';
import { getCleanUrl } from '../../utils/Helper';
import { useCssStyle } from '../../customHook/getCssStyle';
import { CUSTOM_PRELOADER_IMG, CUSTOM_PRELOADER_LOADER, CUSTOM_PRELOADER_VIDEO } from '../../assets';
import { setGoHome, setIsShownWelcomeScreen, setRedirectToTabId, setShowLoginModal } from '../../Redux/Reducers/appConfigReducer';
import { VideoHandler } from '../../components/videoComp/video';
import { useTranslation } from 'react-i18next';
import { ImageComp } from '../../components/Image/Image';
import CustomPressable from '../../components/customPressable/customPressable';
import { CHECK_IN, HOME_PAGE } from '../../navigation/StackNavigator/routes';
import { useNavigation } from '@react-navigation/native';
import { CustomModal } from '../../components/customModal';
import LottieView from 'lottie-react-native';
import FadeTransition from '../../components/fadeTransition';
import RenderHTML from 'react-native-render-html';
import { ISINROOMTAB } from '../../config/Constant';

const WelcomeScreen_Potrait = () => {

  const dispatch = useDispatch();
  const getStyles = useCssStyle();
  const { t } = useTranslation();
  const navigation = useNavigation();
  const {width} = useWindowDimensions();

  const { webAppWidgetsInfo, currentLayout } = useSelector(
    (state) => state.deviceConfigSlice
  );


  const { allowUserLoginViaFindingReservation } = webAppWidgetsInfo?.appConfigs || {};

  const hotelLogoImageUrl = webAppWidgetsInfo?.screenInfoAfterLoader?.hotelLogo ? getCleanUrl(webAppWidgetsInfo?.screenInfoAfterLoader?.hotelLogo)  : getCleanUrl(currentLayout?.brandingInfo?.hotelLogoImageUrl);

  const screenInfo = webAppWidgetsInfo?.screenInfoAfterLoader || {};
  const { backgroundVideo = {}, imageURI, btnAction, logoURI } = screenInfo;
  const { videoURI, posterURI, enableSound } = backgroundVideo;

  const welcomeImg = imageURI ? { uri: getCleanUrl(imageURI) } : CUSTOM_PRELOADER_IMG;
  const welcomeVideo = videoURI ? getCleanUrl(videoURI) : CUSTOM_PRELOADER_VIDEO;
  const welcomePoster = posterURI ? getCleanUrl(posterURI) : CUSTOM_PRELOADER_IMG;


  useEffect(() => {
    // Preload the Home screen in the background
    navigation.preload(HOME_PAGE);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleWelcome = () => {
    dispatch(setIsShownWelcomeScreen(true));
    dispatch(setGoHome(true));
  };


  const handlePrimaryBtnClick = () => {
    const widgetWithPath = btnAction?.params?.appPath?.trim();

    if (widgetWithPath) {

      if (widgetWithPath.toLowerCase() == "findres" || (widgetWithPath == CHECK_IN && allowUserLoginViaFindingReservation)) {
        handleLoginToRoom();
        return;
      }

      handleWelcome();
      setTimeout(() => {
        navigation.navigate(widgetWithPath);
      }, 0);

    }
  }
  const handleLoginToRoom = () => {
    // handleWelcome();
    // dispatch(setRedirectToTabId("mystay"));

    setTimeout(() => {
      dispatch(setShowLoginModal(true));
    }, 200);
  }

  const renderTopLogoSection = () => (
    <View style={getStyles(['welcomeScrTopLogoContainer'])} id='welcomeScrTopLogoContainer'>
      <ImageComp
        source={getCleanUrl(logoURI)}
        style={getStyles(['welcomeScreenTopLogoStyle'])}
        resizeMode="contain"
        id='welcomeScreenTopLogoStyle'
      />
    </View>
  )

  const renderLogoSection = () => (
    <View style={getStyles(['welcomeScrLogoContainer'])} id='welcomeScrLogoContainer'>

      {CUSTOM_PRELOADER_LOADER ?
        <LottieView
          source={CUSTOM_PRELOADER_LOADER}
          style={getStyles(['welcomeScreenLogoLottie'])}
          autoPlay={false}
          progress={1}
          id='welcomeScreenLogoLottie'
        />
        :
        <>
          <ImageComp
            source={hotelLogoImageUrl}
            style={getStyles(['welcomeScreenLogoStyle'])}
            resizeMode="contain"
            id='welcomeScreenLogoStyle'
          />
          <Text style={getStyles(['welcomeScreenLogoText'])} id='welcomeScreenLogoText' >
            {t('welcome_screen.hotel_name')}
          </Text>
        </>
      }
    </View>
  );
  
  const customWidgetTitleStyle = getStyles(['primaryBtnTxt', 'welcomeScreenPrimaryBtnTxt']);
  const customWidgetSubTitleStyle = getStyles(['tertiaryBtnTxt', 'welcomeScreenTertiaryBtnTxt']);
  const customWidgetHeaderTxtStyle = getStyles(['welcomeScreenHeaderTxt']);
  const screenContent = () => (


    <View style={getStyles(['customModalContainer'])} id='customModalContainer'>
      <FadeTransition duration={300}>
        {/* <View style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, backgroundColor: "rgba(0,0,0,0.5)" }}></View> */}

        <View style={getStyles(['customModalInnerContainer', 'welcomeScreenInnerModalContailer_potrait'])} id='customModalInnerContainer welcomeScreenInnerModalContailer_potrait'>

          <View style={getStyles(['welcomeScreenContent'])} id='welcomeScreenContent' >

            <View style={getStyles(['welcomeScreenHeaderTxtCont'])} id='welcomeScreenHeaderTxtCont' >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetHeaderTxtStyle}
                source={{html: t('welcome_screen.welcome_screen_header_msg')}}
                systemFonts={[customWidgetHeaderTxtStyle.fontFamily]}
              />
            </View>

            <CustomPressable style={getStyles(['primaryBtn','welcomeScreenPrimaryBtn'])} id='primaryBtn welcomeScreenPrimaryBtn' onPress={handlePrimaryBtnClick} >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetTitleStyle}
                source={{html: t('welcome_screen.primary_button')}}
                systemFonts={[customWidgetTitleStyle.fontFamily]}
              />
            </CustomPressable>

            <CustomPressable style={getStyles(['tertiaryBtn', 'welcomeScreenTertiaryBtn'])} onPress={handleWelcome} id='tertiaryBtn welcomeScreenTertiaryBtn' >
              <RenderHTML
                contentWidth={width}
                baseStyle={customWidgetSubTitleStyle}
                source={{html: t('welcome_screen.secondary_button')}}
                systemFonts={[customWidgetSubTitleStyle.fontFamily]}
              />
            </CustomPressable>

            {!ISINROOMTAB && <View style={getStyles(['welcomeScreenBottomLoginContainer'])} id='welcomeScreenBottomLoginContainer' >
              <Text style={getStyles(['welcomeScreenBottomLoginTxt'])} id='welcomeScreenBottomLoginTxt' >
                {t('welcome_screen.welcome_screen_login')}
              </Text>
              <CustomPressable onPress={handleLoginToRoom} style={getStyles(['welcomeScreenBottomLoginBtn'])} id='welcomeScreenBottomLoginBtn' >
                <Text style={getStyles(['welcomeScreenBottomLoginBtnTxt'])} id='welcomeScreenBottomLoginBtnTxt' >
                  {t('welcome_screen.welcome_screen_login_button')}
                </Text>
              </CustomPressable>
            </View>}

            <View style={getStyles(['welcomeScreenBottomTxtCont'])} id='welcomeScreenBottomTxtCont' >
              <Text style={getStyles(['welcomeScreenBottomTxt'])} id='welcomeScreenBottomTxt' >
                {t('welcome_screen.welcome_screen_msg')}
              </Text>
            </View>
          </View>
        </View>
      </FadeTransition>
    </View>
  )

  return welcomeVideo ? (
    <View style={getStyles(['welcomeScreenContainer'])} id='welcomeScreenContainer' >
      <View style={getStyles(['welcomeScreenOverlay', {...StyleSheet.absoluteFillObject}])} />
      <VideoHandler
        posterSrc={welcomePoster}
        videoSrc={welcomeVideo}
        enableSound={enableSound}
        style={getStyles(['welcomeScreenVideo'])}
        id='welcomeScreenVideo'
      />
      {renderTopLogoSection()}
      {renderLogoSection()}
      {screenContent()}

    </View>
  ) : (
    <ImageBackground
      source={welcomeImg}
      style={getStyles(['welcomeScreenContainer'])}
      imageStyle={getStyles(['welcomeScreenImage'])}
      resizeMode="cover"
      id='welcomeScreenContainer welcomeScreenContainerImage'
    >
      <View style={getStyles(['welcomeScreenOverlay', {...StyleSheet.absoluteFillObject}])} />
      {renderTopLogoSection()}
      {renderLogoSection()}
      {screenContent()}
    </ImageBackground>
  )
};

export default React.memo(WelcomeScreen_Potrait);
